export enum PaymentStatus {
  FAILED = "failed",
  SUCCESS = "success",
  DUPLICATE = "duplicatePayment",
}
